import { render, staticRenderFns } from "./RoomCallScreenShare.vue?vue&type=template&id=48443b86&scoped=true&"
import script from "./RoomCallScreenShare.vue?vue&type=script&lang=js&"
export * from "./RoomCallScreenShare.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallScreenShare.vue?vue&type=style&index=0&id=48443b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48443b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48443b86')) {
      api.createRecord('48443b86', component.options)
    } else {
      api.reload('48443b86', component.options)
    }
    module.hot.accept("./RoomCallScreenShare.vue?vue&type=template&id=48443b86&scoped=true&", function () {
      api.rerender('48443b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/RoomCallScreenShare.vue"
export default component.exports